module.exports = __webpack_public_path__ + "img/rates.c4d6cde3.svg";